import type { FinancialTableColumn } from "@/features/financialShared";

export const MONTHLY_PROPERTY_COLUMNS: FinancialTableColumn[] = [
	{ id: "name", label: "Property Name" },
	{ id: "totalUnits", label: "Total Units" },
	{ id: "latestServicePeriod", label: "Latest Statement Period" },
	{ id: "lastUpdatedDate", label: "Last Updated Date" },
	{ id: "operatedBy", label: "Operated By" },
	{ id: "action", label: "Actions", align: "right" },
];

export const MONTHLY_SERVICE_PERIOD_COLUMNS: FinancialTableColumn[] = [
	{ id: "period", label: "Statement Period" },
	{ id: "startDate", label: "Start Date" },
	{ id: "endDate", label: "End Date" },
	{ id: "units", label: "Units" },
	{ id: "uploadedDate", label: "Uploaded Date" },
	{ id: "uploadedBy", label: "Uploaded By" },
	{ id: "lastUpdatedBy", label: "Last Updated By" },
	{ id: "action", label: "Actions", align: "right" },
];

export const MONTHLY_UNIT_COLUMNS: FinancialTableColumn[] = [
	{ id: "unit", label: "Unit" },
	{ id: "owner", label: "Owner" },
	{ id: "reportId", label: "Report ID" },
	{ id: "debit", label: "Debit" },
	{ id: "credit", label: "Credit" },
	{ id: "balance", label: "Balance" },
	{ id: "balanceDueDate", label: "Balance Due Date" },
	{ id: "action", label: "Actions", align: "right" },
];

export const MONTHLY_LEDGER_COLUMNS: FinancialTableColumn[] = [
	{ id: "dateInvoice", label: "Date / Invoice / Code" },
	{ id: "concept", label: "Concept" },
	{ id: "itemType", label: "Item Type" },
	{ id: "debit", label: "Debit" },
	{ id: "credit", label: "Credit" },
	{ id: "balance", label: "Balance" },
	{ id: "notes", label: "Notes" },
];

export const MONTHLY_PROPERTY_TABLE_MIN_WIDTH = "min-w-[960px]";
export const MONTHLY_PERIOD_TABLE_MIN_WIDTH = "min-w-[1100px]";
export const MONTHLY_UNIT_TABLE_MIN_WIDTH = "min-w-[1100px]";
export const MONTHLY_LEDGER_TABLE_MIN_WIDTH = "min-w-[1000px]";

export const MONTHLY_PERIOD_STATUS_FILTER = [
	{ value: "", label: "All Status" },
	{ value: "published", label: "Published" },
	{ value: "draft", label: "Draft" },
] as const;

export const MONTHLY_LEDGER_ITEM_TYPE_OPTIONS = [
	{ value: "DEBIT", label: "Debit" },
	{ value: "CREDIT", label: "Credit" },
] as const;

export const MONTHLY_UNIT_SORT_OPTIONS = [
	{ value: "UNIT", label: "Unit" },
	{ value: "BALANCE", label: "Balance" },
] as const;

export const MONTHLY_LISTING_SORT_OPTIONS = [
	{ value: "NAME", label: "Name" },
	{ value: "TOTAL_UNITS", label: "Units" },
	{ value: "LAST_UPDATED", label: "Date" },
] as const;

export const MONTHLY_LISTING_STATUS_FILTER = [
	{ value: "ALL", label: "All Statuses" },
	{ value: "DRAFT", label: "Draft" },
	{ value: "PUBLISHED", label: "Published" },
	{ value: "COMPLETED", label: "Completed" },
] as const;

export const MONTHLY_PAGE_SIZE = 10;
export const MONTHLY_PERIODS_LOOKUP_PAGE_SIZE = 100;

export const MONTHLY_STATEMENT_FILE_MAX_MB = 20;
export const MONTHLY_STATEMENT_FILE_ACCEPT = ".xlsx,.xls";
